// This file is automatically generated from ingestAssets.mjs
import * as React from 'react';
import IconContainer, { IconProps } from '../../../components/IconContainer';

export function WarningBoldIcon(props: IconProps) {
	return (
		<IconContainer {...props}>
			{
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="100%"
					height="100%"
					fill="none"
					viewBox="0 0 32 32"
				>
					<path
						fill="currentColor"
						d="M30.032 23.262 19.102 4.28a3.592 3.592 0 0 0-6.203 0L1.968 23.262a3.431 3.431 0 0 0 0 3.464 3.539 3.539 0 0 0 3.1 1.774h21.863a3.538 3.538 0 0 0 3.099-1.774 3.43 3.43 0 0 0 .002-3.463Zm-2.6 1.963a.557.557 0 0 1-.5.275H5.07a.558.558 0 0 1-.5-.275.445.445 0 0 1 0-.466L15.5 5.775a.596.596 0 0 1 1 0l10.93 18.984a.445.445 0 0 1 .003.466ZM14.5 17v-4a1.5 1.5 0 1 1 3 0v4a1.5 1.5 0 1 1-3 0Zm3.5 5a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z"
					/>
				</svg>
			}
		</IconContainer>
	);
}
